import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";
import { ExclamationCircleIcon } from "@heroicons/react/solid";

const DateField = ({
  name,
  id,
  label,
  labelProps,
  error,
  required,
  disabled,
  onChange,
}) => {
  const [value, setValue] = useState();
  const [isReady, setIsReady] = useState(false);
  const hasError = Boolean(error);
  const hasLabel = Boolean(label);
  const isRequired = Boolean(required);
  const format = "MM/DD/YYYY";
  // eslint-disable-next-line no-unsafe-optional-chaining
  const [month, day, year] = value ? value?.split("/") : [];

  // Wait until after client-side hydration to show because the input mask uses useLayoutEffect
  // Credit: https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
  useEffect(() => {
    setIsReady(true);
  }, []);

  if (!isReady) {
    return null;
  }

  return (
    <>
      <label
        htmlFor={id}
        className={`
          ${hasLabel ? "mb-xs block gn-text-sm text-gray-900" : "sr-only"}
        `}
        {...labelProps}
      >
        {label} {isRequired ? "*" : null}
      </label>
      <InputMask
        maskPlaceholder={format}
        mask={[
          /[0-1]/,
          month?.[0] === "1" ? /[0-2]/ : /[0-9]/,
          "/",
          /[0-3]/,
          day?.[0] === "3" ? /[0-1]/ : /[0-9]/,
          "/",
          /[1-2]/,
          year?.[0] === "1" ? /9/ : /0/,
          /[0-9]/,
          /[0-9]/,
        ]}
        name={name}
        id={id}
        disabled={disabled}
        required={isRequired}
        onChange={({ target }) => {
          setValue(target.value);
          onChange(target.value);
        }}
        placeholder={format}
        className={`block w-full h-input pl-sm gn-text-md rounded border-sm border-gray-300 shadow-lightSM
            ${
              hasError
                ? "text-danger placeholder-danger border-none ring ring-danger focus:ring focus:ring-danger"
                : "text-gray-900 placeholder-gray-500 focus:ring focus:ring-purple focus:outline-none focus:border-none"
            }
           `}
      />
      <div className="mt-xs flex gap-xs" data-testid="error-text-container">
        {hasError ? (
          <>
            <ExclamationCircleIcon
              className="h-input-icon text-danger"
              aria-hidden="true"
            />
            <div className="gn-text-sm text-danger">{error}</div>
          </>
        ) : null}
      </div>
    </>
  );
};

DateField.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  labelProps: PropTypes.shape({}),
  onChange: PropTypes.func,
};

DateField.defaultProps = {
  name: undefined,
  label: undefined,
  id: undefined,
  error: undefined,
  required: null,
  disabled: null,
  labelProps: {},
  onChange: () => {},
};

export default DateField;
